import * as types from '../mutation-types'

const user = {
  state: {
    user: {},
    editUser: {}
  },

  getters: {
    getUser: state => state.user,
    getEditUser: state => state.editUser
  },

  actions: {
    updateUser({ commit }, info) {
      commit(types.UPDATE_USER, info)
    },
    updateEditUser({ commit }, info) {
      commit(types.UPDATE_EDIT_USER, info)
    }
  },

  mutations: {
    [types.UPDATE_USER](state, info) {
      state.user = info
    },
    [types.UPDATE_EDIT_USER](state, info) {
      state.editUser = info
    }
  }
}

export default user
